<template>
  <div class="posts-by-category">
    <template v-for="(cat, index) in categories">
      <h3
        v-if="category === cat.id"
        :key="cat.id"
        :style="{ color: STYLES[index].color, 'text-transform': textTransform }"
      >
        {{ category }}
      </h3>
    </template>

    <h1 style="text-transform: capitalize">{{ post.title }}</h1>
    <div class="author-date">
      <ul>
        <li>
          <strong>{{ post.author }}</strong>
        </li>
        <time>
          {{ moment(post.createdAt).format("MMMM Do, YYYY") }}
        </time>
      </ul>
    </div>
    <hr />
    <b-row>
      <b-col cols="12" md="8" class="latest-post">
        <main>
          <figure>
            <b-img fluid :src="post.imgUrl" :alt="post.title"></b-img>
          </figure>
          <div v-html="post.body" class="mt-4 mb-4"></div>
        </main>
        <hr />
      </b-col>
      <b-col cols="12" md="4" class="mb-4"></b-col>
    </b-row>

    <h3 class="mb-4">Có Thể Bạn Quan Tâm</h3>
    <b-row class="container">
      <b-col cols="12" md="8">
        <b-row v-for="post in posts" :key="post.id" class="other-posts mb-3">
          <b-col cols="4" style="padding-left: 0">
            <b-link :to="{ name: 'post-details', params: { ...post } }">
              <figure class="other-posts_img">
                <b-img fluid :src="post.imgUrl" :alt="post.title"></b-img>
              </figure>
            </b-link>
          </b-col>
          <b-col cols="8" class="other-posts_content">
            <b-link
              :to="{
                name: 'post-details',
                params: { category: post.category, id: post.id },
              }"
            >
              <div>
                <h3 style="text-transform: capitalize">{{ post.title }}</h3>
                <div class="author-date">
                  <ul>
                    <li>
                      <strong>{{ post.author }}</strong>
                    </li>
                    <time>
                      {{ moment(post.createdAt).format("MMMM Do, YYYY") }}
                    </time>
                  </ul>
                </div>
                <div
                  class="post-body"
                  v-html="post.body.split(' ', 30).join(' ')"
                ></div>
              </div>
            </b-link>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="4" class="mb-4"> </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import { getPost, getTenLatestPosts } from "../../firebase/posts";
import { store, STYLES } from "../../firebase/categories";

console.log("store", store);
export default {
  name: "post-details",
  props: {
    category: String,
    id: String,
  },
  data() {
    return {
      post: {},
      posts: [],
      moment,
      store,
      STYLES,
      textTransform: "uppercase",
    };
  },
  watch: {
    idCategory: "load",
  },
  computed: {
    categories() {
      return this.store.categories;
    },
    idCategory() {
      return [this.id, this.category];
    },
  },
  methods: {
    load() {
      getPost(this.id).then((post) => {
        this.post = post;
        window.scrollTo(0, 0);
      }),
        getTenLatestPosts(this.category).then((posts) => {
          this.posts = posts;
          console.log(posts);
        });
    },
  },
  created() {
    this.load();
  },
};
</script>

<style lang="scss">
@import "../../styles/components/posts/PostsByCategory.scss";
</style>
